import { connect } from "react-redux";
import Request from "./Request";
import { bindActionCreators } from "redux";
import { getUseCase, userRequest, clearUserRequest, reconPiTiValidation} from "../../../services/redux/userHelpdesk/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    useCasesList : state.UserHelpdesk.useCasesList,
    saveUserRequest : state.UserHelpdesk.saveUserRequest,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    mrfNumberByInvoiceNumber: state.UserHelpdesk.mrfNumberByInvoiceNumber,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getUseCase,
        userRequest,
        clearUserRequest,
        reconPiTiValidation,
        documentUploadUrlPublic
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Request);